import { render, staticRenderFns } from "./DecisionDiamond.vue?vue&type=template&id=c06ec730&scoped=true"
import script from "./DecisionDiamond.vue?vue&type=script&lang=js"
export * from "./DecisionDiamond.vue?vue&type=script&lang=js"
import style0 from "./DecisionDiamond.vue?vue&type=style&index=0&id=c06ec730&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c06ec730",
  null
  
)

export default component.exports